var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1299 61.5033L44.8066 12.72C43.7833 11.0167 41.9866 10 39.9999 10C38.0133 10 36.2166 11.0167 35.1966 12.7167L5.86994 61.5033C4.82994 63.2333 4.80327 65.3967 5.79661 67.1533C6.78661 68.91 8.65661 70 10.6766 70H69.3266C71.3433 70 73.2166 68.91 74.2066 67.1533C75.1999 65.3967 75.1699 63.2333 74.1299 61.5033ZM41.6666 60H38.3333C37.4133 60 36.6666 59.2533 36.6666 58.3333V55C36.6666 54.08 37.4133 53.3333 38.3333 53.3333H41.6666C42.5866 53.3333 43.3333 54.08 43.3333 55V58.3333C43.3333 59.2533 42.5866 60 41.6666 60ZM39.9999 46.6667C38.1599 46.6667 36.6666 45.1733 36.6666 43.3333V33.3333C36.6666 31.4933 38.1599 30 39.9999 30C41.8399 30 43.3333 31.4933 43.3333 33.3333V43.3333C43.3333 45.1733 41.8399 46.6667 39.9999 46.6667Z",
    fill: "#FE921D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.d67b5cd58d136e63d000652d01a1ddce.svg";
export { ForwardRef as ReactComponent };